"use client";

import React, { useEffect, useRef } from 'react'
import dynamic from 'next/dynamic'

// Create a global reference to track if the widget has been loaded
let widgetLoaded = false;

function TrustIndexReviews() {
  const containerRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Only proceed if widget hasn't been loaded yet
    if (widgetLoaded) {
      return;
    }
    
    // Mark as loaded immediately to prevent other instances
    widgetLoaded = true;
    
    // Remove any existing widgets first (cleanup)
    document.querySelectorAll('.ti-widget, .trustindex-widget, [src*="trustindex.io"]').forEach(element => {
      element.remove();
    });
    
    // Load the script manually with a custom ID
    const script = document.createElement('script');
    script.id = 'trustindex-loader-unique';
    script.src = 'https://cdn.trustindex.io/loader.js?1da3631452819701fd8651a6a02';
    script.async = true;
    
    // Append the script directly to the container
    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }
    
    return () => {
      // Don't remove the script or widget on unmount if it's already loaded
      // This prevents the widget from disappearing when component remounts
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="trustindex-widget-container"
      style={{ minHeight: '200px' }}
    >
      {/* This div will be the only container for the widget */}
      <div
        id="trustindex-widget-unique"
        className="trustindex-widget"
        data-src='https://cdn.trustindex.io/loader.js?1da3631452819701fd8651a6a02'
      />
    </div>
  )
}

// For server-side rendering compatibility and to ensure singleton behavior
export default dynamic(() => Promise.resolve(TrustIndexReviews), { 
  ssr: false 
});
